import {
    MODERATION_FEED_LIST_REQUEST,
    MODERATION_FEED_LIST_RESPONSE,
    MODERATION_FEED_LIST_CACHED_RESPONSE,
    MODERATION_FEED_LIST_ERROR_RESPONSE,
    MODERATION_FEED_ITEM_REQUEST,
    MODERATION_FEED_ITEM_RESPONSE,
    MODERATION_FEED_ITEM_CACHED_RESPONSE,
    MODERATION_FEED_ITEM_ERROR_RESPONSE,
    MODERATION_FEED_ITEM_FULLTEXT_REQUEST,
    MODERATION_FEED_ITEM_FULLTEXT_RESPONSE,
    MODERATION_FEED_ITEM_FULLTEXT_CACHED_RESPONSE,
    MODERATION_FEED_ITEM_FULLTEXT_ERROR_RESPONSE,
    MODERATION_FEED_ITEM_SAVE_REQUEST,
    MODERATION_FEED_ITEM_SAVE_RESPONSE,
    MODERATION_FEED_ITEM_SAVE_ERROR_RESPONSE,
    MODERATION_FEED_ANALYSE_REQUEST,
    MODERATION_FEED_ANALYSE_ERROR_RESPONSE,
} from "./action-types"
import {
    listRequest,
    listResponse,
    listErrorResponse,
    listCachedResponse,
} from "./default-actions/paging-actions"
import {
    itemSaveRequest,
    itemSaveErrorResponse,
    itemRequest,
    itemResponse,
    itemCachedResponse,
    itemErrorResponse,
} from "./default-actions/entity-actions"

// Analyse actions
export const moderationAnalyseRequest = (
    data,
    dataType,
    shouldPersist,
    isSimple,
    callbackActionCreator,
) => ({
    type: MODERATION_FEED_ANALYSE_REQUEST,
    data,
    dataType,
    shouldPersist,
    isSimple,
    callbackActionCreator,
})

export const moderationAnalyseErrorResponse = (
    error,
    dataType,
    shouldPersist,
    isSimple,
    callbackActionCreator,
) => ({
    type: MODERATION_FEED_ANALYSE_ERROR_RESPONSE,
    error,
    data: {},
    dataType,
    shouldPersist,
    isSimple,
    callbackActionCreator,
})

// Entity actions
export const moderationItemSaveRequest = itemSaveRequest(
    MODERATION_FEED_ITEM_SAVE_REQUEST,
)
export const moderationItemSaveResponse = itemResponse(
    MODERATION_FEED_ITEM_SAVE_RESPONSE,
)
export const moderationItemSaveErrorResponse = itemSaveErrorResponse(
    MODERATION_FEED_ITEM_SAVE_ERROR_RESPONSE,
)
export const moderationItemRequest = itemRequest(MODERATION_FEED_ITEM_REQUEST)
export const moderationItemResponse = itemResponse(
    MODERATION_FEED_ITEM_RESPONSE,
)
export const moderationItemCachedResponse = itemCachedResponse(
    MODERATION_FEED_ITEM_CACHED_RESPONSE,
)
export const moderationItemErrorResponse = itemErrorResponse(
    MODERATION_FEED_ITEM_ERROR_RESPONSE,
)
export const moderationItemFulltextRequest = itemRequest(
    MODERATION_FEED_ITEM_FULLTEXT_REQUEST,
)
export const moderationItemFulltextResponse = itemResponse(
    MODERATION_FEED_ITEM_FULLTEXT_RESPONSE,
)
export const moderationItemFulltextCachedResponse = itemCachedResponse(
    MODERATION_FEED_ITEM_FULLTEXT_CACHED_RESPONSE,
)
export const moderationItemFulltextErrorResponse = itemErrorResponse(
    MODERATION_FEED_ITEM_FULLTEXT_ERROR_RESPONSE,
)

// Paging actions
export const moderationListRequest = listRequest(MODERATION_FEED_LIST_REQUEST)
export const moderationListResponse = listResponse(
    MODERATION_FEED_LIST_RESPONSE,
)
export const moderationListCachedResponse = listCachedResponse(
    MODERATION_FEED_LIST_CACHED_RESPONSE,
)
export const moderationListErrorResponse = listErrorResponse(
    MODERATION_FEED_LIST_ERROR_RESPONSE,
)
